var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n\t.st1{fill:#717171;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.5,32C63.5,14.6,49.4,0.5,32,0.5S0.5,14.6,0.5,32c0,15.7,11.5,28.8,26.6,31.1v-22h-8V32h8v-6.9 c0-7.9,4.7-12.3,11.9-12.3c3.4,0,7.1,0.6,7.1,0.6v7.8h-4c-3.9,0-5.1,2.4-5.1,4.9V32h8.7l-1.4,9.1h-7.3v22 C52,60.8,63.5,47.7,63.5,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,41.1l1.4-9.1h-8.7v-5.9c0-2.5,1.2-4.9,5.1-4.9h4v-7.8c0,0-3.6-0.6-7.1-0.6c-7.2,0-11.9,4.4-11.9,12.3V32 h-8v9.1h8v22c1.6,0.3,3.2,0.4,4.9,0.4s3.3-0.1,4.9-0.4v-22H44.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f8d310b5e4bbd5f0cbe1c3b3135bf472.svg";
export { ForwardRef as ReactComponent };